import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { PopType } from 'components/PopOverview/utils'

interface IProps {
  declineBtnText: string
  acceptBtnText: string
  handleClose: (popType: number | undefined) => void
  editMode?: boolean
}

export const TriangleActionsPanel = ({ declineBtnText, acceptBtnText, handleClose, editMode = false }: IProps) => (
  <Flex alignContent="center" flexDirection="column" position="relative">
    <Box
      width="90px"
      height="45px"
      position="absolute"
      top="-55px"
      left="50%"
      transform="translateX(-50%)"
      borderLeft="45px solid transparent"
      borderRight="45px solid transparent"
      borderBottom="45px solid white"
      zIndex={10}
      style={{
        filter: 'drop-shadow(rgba(0, 0, 0, 0.1) 0px -3px 3px)',
      }}
    />

    {/* Белый блок с кнопками */}
    <Flex
      flexDirection="column"
      background="white"
      borderRadius="20px"
      boxShadow="0 2px 8px rgba(0,0,0,0.08)"
      p="16px 24px"
      mt="-10px"
      zIndex={1}
      alignItems="center"
      justifyContent="center"
      minWidth="330px"
    >
      <NoFocusButton
        onClick={() => handleClose(PopType.DEFAULT_POP)}
        variant="solid"
        backgroundColor="transparent"
        color="black"
        borderRadius="999px"
        isDisabled={editMode}
        _hover={{
          backgroundColor: 'transparent',
        }}
      >
        <LocaleText text={declineBtnText} />
      </NoFocusButton>
      <NoFocusButton
        onClick={() => handleClose(PopType.AI_RE_POP)}
        variant="solid"
        backgroundColor="black"
        color="white"
        fontWeight="bold"
        borderRadius="999px"
        isDisabled={editMode}
        _hover={{
          opacity: 0.8,
        }}
      >
        <LocaleText text={acceptBtnText} />
      </NoFocusButton>
    </Flex>
  </Flex>
)
